import { getUrl, Request } from "../../request";

export const getPollQuestions = (category_id) => {
  return Request.get(getUrl("/api/v1/rates/poll-questions/"), {
    category_id,
    type: "returned",
  });
};

export const postRate = (token, rate, items) => {
  return Request.post(getUrl("/api/v1/rates/rate/"), {
    token,
    rate,
    items,
  });
};
